import gButton from "@/components/g-button/g-button.vue";
import gCard from "@/components/g-card/g-card.vue";
import gPdf from "@/components/g-pdf/g-pdf.vue";
import PedidoController from "@/shared/controllers/pedido/PedidoController";
import PedidoObservacoesViewModel from "@/shared/view-models/PedidoObservacoesViewModel";
import DetalhesDoPedidoFluxoViewModel from "@/shared/view-models/DetalhesDoPedidoFluxoViewModel";
import Tools from "@/shared/services/tools";
import ObservacoesPedidoEmAndamentoPDF from "./PDF/ObservacoesPedidoEmAndamentoPDF.vue"

import { defineComponent } from "vue";

const name = 'ObservacoesPedidoEmAndamento'
export default defineComponent({
  name,


  components: {
    "g-button": gButton,
    "g-card": gCard,
    "g-pdf": gPdf,
    ObservacoesPedidoEmAndamentoPDF
  },


  props: {
  },


  mounted() {
    this.pedidoId = this.$route.params.id
    this.numeroParcela = this.$route.params.numeroParcela
    var pedId = this.$route.params.id
    this.PedidoId = pedId
    this.getDetalhesObservacoes()
    this.getObservacoes()
    this.getDetalhesDoPedido();
  },


  updated() { },


  data() {
    return {
      pedidoId: null,
      numeroParcela: null,
      observacoesInfoArray: [],
      CompFaseArray: [],
      observacoesPedidoAndamento: new PedidoObservacoesViewModel(),
      detalhesDoPedidoFluxo : new DetalhesDoPedidoFluxoViewModel(),
      PedidoId: null,
      executarvisualizacao: 0,
      renderiza: false,
    }
  },

  methods: {
    formataDecimal(valor){
      return Tools.valorDecimalFormatado(valor)
    },

    formataMonetario(valor){ 
      return Tools.valorMonetario4Digitos(valor)
    },
    gerarPdf() {
      this.executarvisualizacao++
    },
    voltar() {
      this.$router.back()
    },

    getDetalhesDoPedido() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetDetalhesDoPedidoFluxo/${this.$route.params.id}`,
      })
        .then((response) => {
          Tools.objectCustomAssign(this.detalhesDoPedidoFluxo, Tools.captalizeKeys(response.data.data))
        })
        .catch(() => {
        });
    },


    getDetalhesObservacoes() {
      PedidoController.GetDetalhesObservacoesPedidoAndamento(this.pedidoId, this.numeroParcela).requisicao
        .then((res => {
          Tools.objectCustomAssign(this.observacoesPedidoAndamento, Tools.captalizeKeys(res.data.data))
        }))
        .catch(() => {
        })
    },


    getObservacoes() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetObservacoesDoPedido/${this.$route.params.id}/${this.numeroParcela}`,
      })
        .then((response) => {
          this.observacoesInfoArray = response.data.data;
          this.GetComponentesEFases()
        })
        .catch(() => {
        });
    },

    GetComponentesEFases(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetPedidosComponentesParcela/${this.$route.params.id}/${this.numeroParcela}`,
      })
        .then((response) => {
          this.CompFaseArray = response.data.data;
        })
        .catch(() => {
        });
    },
    imprimir()
    {
      this.renderiza = true
      this.PedidoId = this.$route.params.id
      this.executarvisualizacao++
    },

  },

  computed: {},

});